import { PageHeader } from "@ant-design/pro-components";
import { Button, Flex, Steps } from "antd";
import { observer } from 'mobx-react';
import React, { useEffect } from "react";
import Subjects from "../../models/subjects";
import TicketTypes from "../../models/ticket-type";
import { useStore } from "../../stores/root-store";
import '../common/page-header.css';

const TicketClones: React.FC<{ subject: Subjects }> = ({ subject }) => {

    const { subjectStores, authStore } = useStore();
    const newTicket = subjectStores[subject].newTicket;

    useEffect(() => {

        if (authStore.isAuthenticated) {
            newTicket.loadFull();
        }
    }, [newTicket, authStore.isAuthenticated]
    );

    const handleClickMakePdf = () => {
        newTicket.makePdf();
    }
    const handleRegeneratePdf = () => {
        newTicket.regeneratePdf();
    }

    const handleClickFinish = () => {
        newTicket.finish();
    }

    const mappedTasks = newTicket.getParentTaskAsSteps();

    return (
        <div className="content">
            {newTicket.parentId &&
                <PageHeader title={`Создание ${newTicket.ticketType === TicketTypes.THEMATIC ? "тематического" : "ЕГЭ"} варианта-клона ${newTicket.parentId}`}
                    className="site-page-header" />}
            {/* Начать создание варианта */}
            <Flex vertical gap="middle">
                {newTicket.id &&
                    <div>
                        <Flex gap="middle">
                            <Steps progressDot items={mappedTasks} direction="vertical" />
                        </Flex>
                        <Flex justify="flex-end" gap="middle">
                            {newTicket.pdfLink &&
                                <Button type='link' href={newTicket.pdfLink}>Скачать PDF</Button>
                            }
                            {/* Перегенерировать PDF */}
                            {newTicket.pdfLink &&
                                <Button type='primary' onClick={handleRegeneratePdf}>Перегенерировать PDF</Button>
                            }
                            {/* Продолжить создание и выгрузить PDF при полном заполнении */}
                            {!newTicket.pdfLink &&
                                <Button type="primary" onClick={handleClickMakePdf}>Сформировать PDF</Button>
                            }
                            {/* Завершить формирование варианта */}
                            <Button danger onClick={handleClickFinish}>Закончить создание</Button>
                        </Flex>
                    </div>
                }
            </Flex>
        </div>
    );
};


export default observer(TicketClones);